export default __webpack_public_path__ + "static/media/Eye_2_M_C6.d346bb40.svg";